var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "借贷项订单",
            visible: _vm.show,
            size: "90%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                disabled: _vm.type == "查看" || _vm.isRejectTo,
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SAP销售单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sapOrderSn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapOrderSn", $$v)
                                  },
                                  expression: "form.sapOrderSn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据类型", prop: "salesType" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeSalesType },
                                  model: {
                                    value: _vm.form.salesType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "salesType", $$v)
                                    },
                                    expression: "form.salesType",
                                  },
                                },
                                _vm._l(_vm.salesTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "交货单号",
                                prop: "deliveryOrderSn",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "选择交货单带出" },
                                  model: {
                                    value: _vm.form.deliveryOrderSn,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryOrderSn", $$v)
                                    },
                                    expression: "form.deliveryOrderSn",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectDeliveryOrder },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售组织",
                                prop: "salesOrganizationId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "选择交货单带出",
                                    disabled: true,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getOptionOrganization(
                                        _vm.form.salesOrganizationId
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.form.salesOrganizationId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "salesOrganizationId",
                                        $$v
                                      )
                                    },
                                    expression: "form.salesOrganizationId",
                                  },
                                },
                                _vm._l(
                                  _vm.salesOrganizationOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "分销渠道",
                                prop: "channelOfDistributionId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "选择交货单带出",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getProductTeamOption(
                                        _vm.form.channelOfDistributionId
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.form.channelOfDistributionId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "channelOfDistributionId",
                                        $$v
                                      )
                                    },
                                    expression: "form.channelOfDistributionId",
                                  },
                                },
                                _vm._l(
                                  _vm.channelDistributioOption,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "产品组", prop: "productTeamId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "选择交货单带出",
                                  },
                                  model: {
                                    value: _vm.form.productTeamId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "productTeamId", $$v)
                                    },
                                    expression: "form.productTeamId",
                                  },
                                },
                                _vm._l(_vm.productTeamOption, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "业务类型",
                                prop: "businessTypeId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.businessTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "businessTypeId", $$v)
                                    },
                                    expression: "form.businessTypeId",
                                  },
                                },
                                _vm._l(
                                  _vm.businessTypeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "售达方",
                                prop: "soldToPartyName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择交货单带出",
                                },
                                model: {
                                  value: _vm.form.soldToPartyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "soldToPartyName", $$v)
                                  },
                                  expression: "form.soldToPartyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "送达方",
                                prop: "deliverySideName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择交货单带出",
                                },
                                model: {
                                  value: _vm.form.deliverySideName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deliverySideName", $$v)
                                  },
                                  expression: "form.deliverySideName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据状态", prop: "status" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.statusArr[_vm.form.status],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statusArr,
                                      _vm.form.status,
                                      $$v
                                    )
                                  },
                                  expression: "statusArr[form.status]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "交货工厂", prop: "factoryId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "选择交货单带出",
                                  },
                                  model: {
                                    value: _vm.form.factoryId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "factoryId", $$v)
                                    },
                                    expression: "form.factoryId",
                                  },
                                },
                                _vm._l(_vm.factoryOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "中间公司",
                                prop: "middleCompanyId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择交货单带出",
                                },
                                model: {
                                  value: _vm.form.middleCompanyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "middleCompanyName", $$v)
                                  },
                                  expression: "form.middleCompanyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createUser,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createUser", $$v)
                                  },
                                  expression: "form.createUser",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createTime", $$v)
                                  },
                                  expression: "form.createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "订货原因",
                                prop: "orderGoodsCause",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.orderGoodsCause,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderGoodsCause", $$v)
                                    },
                                    expression: "form.orderGoodsCause",
                                  },
                                },
                                _vm._l(_vm.orderReasonOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.desc,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据日期", prop: "orderTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.orderTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderTime", $$v)
                                  },
                                  expression: "form.orderTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "附件信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("FileUpload", {
                        attrs: {
                          "file-type": [
                            "png",
                            "jpg",
                            "jpeg",
                            "doc",
                            "xls",
                            "pdf",
                            "xlsx",
                            "docx",
                          ],
                          value: _vm.form.loanOrderAccessoryParamList,
                          "show-delect":
                            _vm.form.status <= 1 || _vm.form.status == null,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "loanOrderAccessoryParamList",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "订单明细" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activePaneName,
                        callback: function ($$v) {
                          _vm.activePaneName = $$v
                        },
                        expression: "activePaneName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "配件", name: "mountings" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addMountingsLine()
                                    },
                                  },
                                },
                                [_vm._v("配件明细")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.showObj.mountings,
                                  expression: "showObj.mountings",
                                },
                              ],
                              ref: "mountingsTable",
                              attrs: {
                                height: "400px",
                                data: _vm.form.mountingsList,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "订单数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "mountingsList." +
                                                scope.$index +
                                                ".qty",
                                              rules: _vm.mountingsList.qty,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                min: "0",
                                                type: "number",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.sumLordDutyPrice(
                                                    scope.row,
                                                    scope.$index,
                                                    "mountings"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "单位",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "unit" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "unit",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.unit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "含税单价",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "mountingsList." +
                                                scope.$index +
                                                ".taxPrice",
                                              rules: _vm.mountingsList.taxPrice,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                min: "0",
                                                type: "number",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.sumLordDutyPrice(
                                                    scope.row,
                                                    scope.$index,
                                                    "mountings"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.taxPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "税率(%)",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "taxRatio" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder:
                                                  "头部的销售组织带出",
                                              },
                                              model: {
                                                value: scope.row.taxRatio,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxRatio",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxRatio",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "含税金额",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "lordDutyPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.lordDutyPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "lordDutyPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.lordDutyPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "不含税金额",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "taxlessPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.taxlessPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxlessPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxlessPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "batch" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.batch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "batch",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.batch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "OE",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "oeCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.oeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "oeCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.oeCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车辆ID",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "carId" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.carId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "carId",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.carId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车牌",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "carNo" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.carNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "carNo",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.carNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "品牌",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "brand" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.brand,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "brand",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.brand",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车系",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "series" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.series,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "series",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.series",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "年款",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "modelYear" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.modelYear,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "modelYear",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.modelYear",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "发动机型号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "engineModel" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.engineModel,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "engineModel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.engineModel",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "变速箱型号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "transmissionModel",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value:
                                                  scope.row.transmissionModel,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "transmissionModel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.transmissionModel",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "排量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "displacement" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.displacement,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "displacement",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.displacement",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "说明",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "note" } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "请输入" },
                                              model: {
                                                value: scope.row.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleMountingsDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "废料", name: "flotsam" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addFlotsamLine()
                                    },
                                  },
                                },
                                [_vm._v("废料明细")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.showObj.flotsam,
                                  expression: "showObj.flotsam",
                                },
                              ],
                              ref: "flotsamTable",
                              attrs: {
                                height: "400px",
                                data: _vm.form.flotsamList,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "订单数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "flotsamList." +
                                                scope.$index +
                                                ".qty",
                                              rules: _vm.flotsamList.qty,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                min: "0",
                                                placeholder: "请输入",
                                                type: "number",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.sumLordDutyPrice(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "单位",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "unit" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "unit",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.unit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "含税单价",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "flotsamList." +
                                                scope.$index +
                                                ".taxPrice",
                                              rules: _vm.flotsamList.taxPrice,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                min: "0",
                                                placeholder: "请输入",
                                                type: "number",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.sumLordDutyPrice(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.taxPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "税率(%)",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "taxRatio" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder:
                                                  "头部的销售组织带出",
                                              },
                                              model: {
                                                value: scope.row.taxRatio,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxRatio",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxRatio",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "含税金额",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "lordDutyPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.lordDutyPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "lordDutyPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.lordDutyPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "不含税金额",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "taxlessPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.taxlessPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "taxlessPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.taxlessPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "说明",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "note" } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "请输入" },
                                              model: {
                                                value: scope.row.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.form.salesType === 2
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "产值差异原因",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "lowPriceReason",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder: "请选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .lowPriceReason,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "lowPriceReason",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.lowPriceReason",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.lowPriceReasons,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      317220371
                                    ),
                                  })
                                : _vm._e(),
                              _vm.form.salesType === 2
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "产值差异图片",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "260",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "fileList" } },
                                                [
                                                  _c("UploadPicture", {
                                                    attrs: {
                                                      "file-type": [
                                                        "png",
                                                        "jpg",
                                                        "jpeg",
                                                      ],
                                                      "show-delect": true,
                                                      "reference-id":
                                                        scope.row.id,
                                                      "reference-table":
                                                        "crm_sales_on_loan_order_line",
                                                      attribute1: "扣杂凭证",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1622069189
                                    ),
                                  })
                                : _vm._e(),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleFlotsamDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "流程审批" } },
                [
                  _vm.form.status <= 1 || _vm.form.status == null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "选择流程模板",
                                        prop: "flowPathTemplateId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "选择模板" },
                                          on: {
                                            change: _vm.getFlowTempInfoList,
                                          },
                                          model: {
                                            value: _vm.form.flowPathTemplateId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "flowPathTemplateId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.flowPathTemplateId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.flowPathOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.templateName,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.flowPathNodePersonModels &&
                          _vm.form.flowPathNodePersonModels.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "elTable",
                                  staticStyle: { width: "50%" },
                                  attrs: {
                                    data: _vm.form.flowPathNodePersonModels,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "节点名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "nodePersonName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.nodePersonName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3691834225
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "审批人",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "auto",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flowPathNodePersonModels." +
                                                      scope.$index +
                                                      ".nodePerson",
                                                    rules:
                                                      _vm
                                                        .flowPathNodePersonModels
                                                        .nodePerson,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.nodePerson,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nodePerson",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nodePerson",
                                                      },
                                                    },
                                                    [
                                                      scope.row.variable
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              slot: "append",
                                                              icon: "el-icon-search",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectNodePerson(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            slot: "append",
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4032877737
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("Flow", {
                    ref: "flow",
                    attrs: {
                      disabled: _vm.type == "查看" || _vm.form.status > 2,
                      "custom-event": true,
                      "flow-id": _vm.form.flowId,
                    },
                    on: {
                      flowLoad: _vm.flowLoad,
                      complete: _vm.onComplete,
                      refresh: _vm.flowRefresh,
                      rejectTo: _vm.flowRejectTo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: [3].includes(_vm.form.status),
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndSubmit()
                            },
                          },
                        },
                        [_vm._v("提交审核")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择审批人",
            visible: _vm.showObj.nodePerson,
            width: "30%",
            "before-close": _vm.nodePersonClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "nodePerson", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入审批人名称" },
                    model: {
                      value: _vm.condition.nodePerson.nodePerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.nodePerson, "nodePerson", $$v)
                      },
                      expression: "condition.nodePerson.nodePerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNodePersonDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.nodePerson, border: "", height: "300" },
              on: { "selection-change": _vm.handleNodePersonSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审批人",
                  align: "left",
                  prop: "nodePerson",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.nodePerson.total,
                  page: _vm.pagination.nodePerson.current,
                  limit: _vm.pagination.nodePerson.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.nodePerson,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.nodePerson, "size", $event)
                  },
                  pagination: _vm.getNodePersonDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.nodePersonClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nodePersonConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择售达方",
            visible: _vm.showObj.soldToParty,
            width: "60%",
            "before-close": _vm.soldToPartyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "soldToParty", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.soldToParty.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.soldToParty,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.soldToParty.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSoldToPartyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.soldToParty,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSoldToPartySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户类型",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.customerType == 1
                          ? _c("span", [_vm._v("固定")])
                          : _vm._e(),
                        scope.row.customerType == 2
                          ? _c("span", [_vm._v("零星")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "经营类别",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("operateCategoryFilters")(
                                scope.row.operateCategory
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系人",
                  align: "left",
                  prop: "contacts",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系方式",
                  align: "left",
                  prop: "contactsPhone",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "详细地址",
                  align: "left",
                  prop: "address",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据状态",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.soldToParty.total,
                  page: _vm.pagination.soldToParty.current,
                  limit: _vm.pagination.soldToParty.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.soldToParty,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.soldToParty, "size", $event)
                  },
                  pagination: _vm.getSoldToPartyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.soldToPartyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.soldToPartyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择送达方",
            visible: _vm.showObj.deliverySide,
            width: "60%",
            "before-close": _vm.deliverySideClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "deliverySide", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.deliverySide.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliverySide,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.deliverySide.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getDeliverySideDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.deliverySide,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleDeliverySideSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户类型",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.customerType == 1
                          ? _c("span", [_vm._v("固定")])
                          : _vm._e(),
                        scope.row.customerType == 2
                          ? _c("span", [_vm._v("零星")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "经营类别",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("operateCategoryFilters")(
                                scope.row.operateCategory
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系人",
                  align: "left",
                  prop: "contacts",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系方式",
                  align: "left",
                  prop: "contactsPhone",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "详细地址",
                  align: "left",
                  prop: "address",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据状态",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.deliverySide.total,
                  page: _vm.pagination.deliverySide.current,
                  limit: _vm.pagination.deliverySide.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.deliverySide,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.deliverySide, "size", $event)
                  },
                  pagination: _vm.getDeliverySideDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.deliverySideClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deliverySideConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择中间公司",
            visible: _vm.showObj.middleCompany,
            width: "60%",
            "before-close": _vm.middleCompanyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "middleCompany", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入销售客户名称" },
                    model: {
                      value: _vm.condition.middleCompany.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.middleCompany,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.middleCompany.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMiddleCompanyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.middleCompany,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleMiddleCompanySelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织编码",
                  align: "left",
                  prop: "salesOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售客户",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织编码",
                  align: "left",
                  prop: "purchasingOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织",
                  align: "left",
                  prop: "purchasingOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购供应商",
                  align: "left",
                  prop: "supplierName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.middleCompany.total,
                  page: _vm.pagination.middleCompany.current,
                  limit: _vm.pagination.middleCompany.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getMiddleCompanyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.middleCompanyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.middleCompanyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "交货单",
            visible: _vm.showObj.deliveryOrder,
            width: "70%",
            "before-close": _vm.deliveryOrderClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "deliveryOrder", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入交货单号" },
                    model: {
                      value: _vm.condition.deliveryOrder.deliveryOrderSn,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliveryOrder,
                          "deliveryOrderSn",
                          $$v
                        )
                      },
                      expression: "condition.deliveryOrder.deliveryOrderSn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入售达方" },
                    model: {
                      value: _vm.condition.deliveryOrder.soldToPartyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliveryOrder,
                          "soldToPartyName",
                          $$v
                        )
                      },
                      expression: "condition.deliveryOrder.soldToPartyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入SAP销售单号" },
                    model: {
                      value: _vm.condition.deliveryOrder.sapSalesOrderSn,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliveryOrder,
                          "sapSalesOrderSn",
                          $$v
                        )
                      },
                      expression: "condition.deliveryOrder.sapSalesOrderSn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入SAP交货单号" },
                    model: {
                      value: _vm.condition.deliveryOrder.sapDeliverySn,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliveryOrder,
                          "sapDeliverySn",
                          $$v
                        )
                      },
                      expression: "condition.deliveryOrder.sapDeliverySn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getDeliveryOrderDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.deliveryOrder,
                  expression: "loadingObj.deliveryOrder",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.deliveryOrder,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleDeliveryOrderSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "交货单号",
                  align: "left",
                  prop: "deliveryOrderSn",
                  "show-overflow-tooltip": "",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SAP销售单号",
                  align: "left",
                  prop: "sapOrderSn",
                  width: "130",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SAP交货单号",
                  align: "left",
                  prop: "sapDeliverySn",
                  width: "130",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "售达方",
                  align: "left",
                  prop: "soldToPartyName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "送达方",
                  align: "left",
                  prop: "deliverySideName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.deliveryOrder.total,
                  page: _vm.pagination.deliveryOrder.current,
                  limit: _vm.pagination.deliveryOrder.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.deliveryOrder,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.deliveryOrder,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getDeliveryOrderDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.deliveryOrderClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deliveryOrderConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品配料",
            visible: _vm.showObj.mountings,
            width: "70%",
            "before-close": _vm.mountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "mountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.mountings.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productName", $$v)
                      },
                      expression: "condition.mountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.mountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productCode", $$v)
                      },
                      expression: "condition.mountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.mountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "oeCode", $$v)
                      },
                      expression: "condition.mountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.mountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "carNo", $$v)
                      },
                      expression: "condition.mountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.mountings,
                  expression: "loadingObj.mountings",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.mountings, border: "", height: "300" },
              on: { "selection-change": _vm.handleMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.mountings.total,
                  page: _vm.pagination.mountings.current,
                  limit: _vm.pagination.mountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "size", $event)
                  },
                  pagination: _vm.getMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品废料",
            visible: _vm.showObj.flotsam,
            width: "60%",
            "before-close": _vm.flotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "flotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.flotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productName", $$v)
                      },
                      expression: "condition.flotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.flotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productCode", $$v)
                      },
                      expression: "condition.flotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.flotsam,
                  expression: "loadingObj.flotsam",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.flotsam, border: "", height: "300" },
              on: { "selection-change": _vm.handleFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.flotsam.total,
                  page: _vm.pagination.flotsam.current,
                  limit: _vm.pagination.flotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "size", $event)
                  },
                  pagination: _vm.getFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.flotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.flotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }